import { RouteConfig } from "QuorumGrassroots/framework/helpers/RouteRegistry"
import { keyDatesRoutes } from "QuorumGrassroots/pages/campaign/key-dates/routes"
import { voterInformationRoutes } from "QuorumGrassroots/pages/campaign/voter-information/routes"
import { electedOfficialsRoutes } from "QuorumGrassroots/pages/campaign/elected-officials/routes"
import { exploreCandidatesRoutes } from "QuorumGrassroots/pages/campaign/candidates/routes"

export const campaignRoutes: RouteConfig[] = [
    ...keyDatesRoutes,
    ...voterInformationRoutes,
    ...electedOfficialsRoutes,
    ...exploreCandidatesRoutes,
]
